import React, { useMemo, useState } from "react";
import "../pages/Cermati.css";

// PDF Viewer
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

// Import PDF files
import pdf6 from "../assets/struktur-narasi-cerdas.pdf";
import pdf7 from "../assets/cerdas-menulis-cerita.pdf";

const BahanBelajarContent = ({ onOpenCermati }) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const pdfList3 = useMemo(
    () => [
      {
        id: 1,
        name: "Struktur Narasi CERDAS",
        file: pdf6,
        color: "#4ECDC4",
      },
      {
        id: 2,
        name: "Cerdas Menulis Cerita",
        file: pdf7,
        color: "#6A0572",
      },
    ],
    []
  );

  const [selectedPdf, setSelectedPdf] = useState(pdfList3[0]);

  return (
    <div className="bahan-container">
      <div className="bahan-header">
        <h2>📚 Bahan Belajar</h2>
        <p className="bahan-subtitle">
          Ringkasan materi yang sama tersedia di <strong>Cermati → Materi Pembelajaran</strong>.
          Gunakan halaman ini untuk akses cepat tanpa membuka dialog Cermati.
        </p>
        {onOpenCermati && (
          <button type="button" className="bahan-cermati-link" onClick={onOpenCermati}>
            👀 Buka di Ruang Cermati
          </button>
        )}
      </div>

      <div className="pdf-viewer-layout">
        {/* PDF Sidebar */}
        <div className="pdf-sidebar">
          <div className="sidebar-header">
            <h3>📚 Materi Pembelajaran</h3>
            <span className="pdf-count">{pdfList3.length} PDF Tersedia</span>
          </div>

          <div className="pdf-list">
            {pdfList3.map((pdf) => (
              <div
                key={pdf.id}
                className={`pdf-item ${selectedPdf?.id === pdf.id ? "active" : ""}`}
                onClick={() => setSelectedPdf(pdf)}
                style={{ borderLeft: `4px solid ${pdf.color}` }}
              >
                <div className="pdf-item-icon">📄</div>
                <div className="pdf-item-content">
                  <div className="pdf-item-title">{pdf.name}</div>
                </div>
                <div className="pdf-item-badge" style={{ background: pdf.color }}>
                  {pdf.id}
                </div>
              </div>
            ))}
          </div>

          {/* External Links Section */}
          <div className="external-links-section">
            <h4>🌐 Sumber Belajar Eksternal</h4>
            <div className="external-links">
              <a
                href="https://g.co/gemini/share/6f5ef3cffa24"
                target="_blank"
                rel="noopener noreferrer"
                className="external-link"
              >
                <div className="external-link-icon">🎨</div>
                <div className="external-link-content">
                  <div className="external-link-title">Digital Storytelling (Link Gemini)</div>
                </div>
              </a>

              <a
                href="https://g.co/gemini/share/ac65ad7d64be"
                target="_blank"
                rel="noopener noreferrer"
                className="external-link"
              >
                <div className="external-link-icon">🎬</div>
                <div className="external-link-content">
                  <div className="external-link-title">ADIKSIMBA (Link Gemini)</div>
                </div>
              </a>

              <a
                href="https://g.co/gemini/share/b0d8b66bc3f7"
                target="_blank"
                rel="noopener noreferrer"
                className="external-link"
              >
                <div className="external-link-icon">✍️</div>
                <div className="external-link-content">
                  <div className="external-link-title">Menulis Narasi (Link Gemini)</div>
                </div>
              </a>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="quick-actions-sidebar">
            <h4>🚀 Aksi Cepat</h4>
            <div className="action-buttons">
              <a className="action-btn download" href={selectedPdf?.file} download>
                📥 Unduh
              </a>
              <button className="action-btn print" onClick={() => window.print()}>
                🖨️ Print
              </button>
              <button
                className="action-btn share"
                onClick={() => navigator.clipboard?.writeText(window.location.href)}
              >
                📤 Bagikan
              </button>
            </div>
          </div>
        </div>

        {/* PDF Viewer Area */}
        <div className="pdf-viewer-area">
          {selectedPdf && (
            <>
              <div className="pdf-viewer-header">
                <div className="pdf-info">
                  <h3>{selectedPdf.name}</h3>
                </div>
                <div className="pdf-status">
                  <span className="status-badge">🟢 Tersedia</span>
                </div>
              </div>

              <div className="pdf-container">
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                  <Viewer
                    fileUrl={selectedPdf.file}
                    plugins={[defaultLayoutPluginInstance]}
                    defaultScale={1.0}
                  />
                </Worker>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default BahanBelajarContent;